/* eslint-disable vue/valid-v-slot */

import alert from '@/plugins/alert'
import { TeacherExam } from '@/plugins/api'
/* eslint-disable no-unused-vars */

export default {
  namespaced: true,
  state: {
    count: 0,
    teachers: [],
    teacherSearchParams: {},
    pageText: '',
    loading: false
  },
  actions: {
    async fetchTeacherExams({ commit }, options) {
      return TeacherExam.fetch({ ...options })
    },
    async fetchTeacherExam({ commit }, id) {
      return TeacherExam.fetchOne(id)
    },
    async createTeacherExam({ commit }, data) {
      return TeacherExam.create(data)
    },
    async updateTeacherExam({ commit }, { id, ...data }) {
      return TeacherExam.update(id, { ...data })
    },
    async countTeacherExams({ commit }, options) {
      return TeacherExam.count(options)
    },
    async removeTeacherExam({ commit }, id) {
      await TeacherExam.remove(id)
      alert.success('Bỏ giáo viên ra khỏi kỳ thi thành công')
    }
  }
}
